import React, { useEffect, useContext } from 'react'
import { NavLink } from 'react-router-dom';
import ScrollToTop from '../../Shared/ScrollToTop';
import PushNotificationList from './../../../assets/images/module/admin-panel/push-notification/push-notification-list.png';
import PushNotificationCreate from './../../../assets/images/module/admin-panel/push-notification/push-notification-create.png';
import { ProjectTypeContext } from '../../../ContextHandle';
export default function PushNotification({ setActivePage, sectionRefs, setDefaultWebActiveMenu }) {
 /* eslint-disable */
    var projectType = useContext(ProjectTypeContext);
    const projectName = projectType.projectName;
    const panelName   = projectType.panelName;
    projectType = projectType.projectType;
    useEffect(() => {
        setActivePage(1020);
        document.title = 'Push notification | ' + projectName + ' web';
        setDefaultWebActiveMenu(2);
    }, [projectName]);
    return (
        <div className='d-flex flex-column justify-content-between doc-page'>
            <ScrollToTop></ScrollToTop>
            <div className=" right-content-box-width">
                <nav >
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href={`/${projectType}/introduction`}><i className='fa fa-home'></i></a></li>
                        <li className="breadcrumb-item" aria-current="page">{panelName}</li>
                        <li className="breadcrumb-item active" aria-current="page">Push Notification</li>
                    </ol>
                </nav>

                <div id="parcels" ref={sectionRefs['38']}>
                    <h4 className="  mt-5 font-weight-bold ">Push Notification</h4>
                    <p className="">Users often need to give notifications and for that there is a notification module. Notifications need to be created to give notifications.</p>
                    <h4 className=" pt-3">Push Notification List </h4>
                    <div className='pt-3'>
                        <img src={PushNotificationList} className="w-100 rounded" alt="Parcel Lists"></img>
                    </div>
                    <h4 className=" pt-3">Push Notification Create </h4>
                    <div className='pt-3'>
                        <img src={PushNotificationCreate} className="w-100 rounded" alt="Parcel Lists"></img>
                    </div>
                </div>

                <div className="d-flex justify-content-between border-top mt-5">
                    <div className="text-start mt-4">
                        <NavLink to={`/${projectType}/reports`} className="text-decoration-none">
                            <a href='/' className="mb-0 text-decoration-none text-secondary">Previous <i className="bi bi-caret-left" /></a>
                            <h4 className='pagination-title'>Reports</h4>
                        </NavLink>
                    </div>
                    <div className="text-end my-2">
                        <NavLink to={`/${projectType}/addons`} className="text-decoration-none">
                            <a href="#login" id="quickStartGuide" className="mb-0 text-decoration-none text-secondary">Next <i className="bi bi-caret-right" /></a>
                            <h4 className='pagination-title'>Addons</h4>
                        </NavLink>
                    </div>
                </div>
                
            </div>
        </div>
    )
}
